export default {"src":"/_next/static/media/metal.765917ab.svg","height":27,"width":32};